import styled from 'styled-components6';
import { JobCards } from '../../Layout/FeaturedContent/JobCards';
import { useContentLists } from '../../fetchers';
import { JobListProvider } from '../../providers';
import { H6 } from 'rwl-ui';

const SimilarJobsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--rwl-spacing-md);
`;

export const JobDetailsSimilarJobs = (): JSX.Element => {
    const { similarJobList } = useContentLists();
    return (
        <JobListProvider jobsList={similarJobList}>
            <SimilarJobsContainer className={'jobDetailsSimilarJobs'}>
                <hr
                    style={{
                        color: 'var(--rwl-palette-gray-500)',
                        width: '100%',
                        borderTop: 'none',
                        borderLeft: 'none',
                    }}
                />
                <H6>Similar Jobs</H6>
                <JobCards />
            </SimilarJobsContainer>
        </JobListProvider>
    );
};
